import { IInitialState } from 'src/store/initialState';

const allAddressesSelector = (
  state: IInitialState
): IInitialState['addresses'] => state.addresses;

export const addressesSel = (state: IInitialState) =>
  allAddressesSelector(state).addresses;
export const addressesIsPendingSel = (state: any) =>
  allAddressesSelector(state).isPending;
export const addressesErrorSel = (state: any) =>
  allAddressesSelector(state).error;
